// Get the base URL from environment or default to localhost
const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

// Function to get the complete image URL
export const getImageUrl = (imagePath) => {
  if (!imagePath) return null;
  
  // If it's already a full URL, return as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  // If it's a relative path, append it to the base URL
  return `${BASE_URL}${imagePath}`;
}; 